import { Button, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import React from 'react';

import MHButton from 'src/components/MHButton';

import { CalendarModalTestID } from './CalendarModal.models';
import { useStyles } from './CalendarModal.styles';
import { CalendarModalDeleteIcon } from './CalendarModalDeleteIcon';

interface Props {
  cancelDelete: () => void;
  doDelete: () => void;
  deleteProfileName: string;
  isLastCalendar: boolean;
  working: boolean;
}

const LAST_CALENDAR_CONFIRMATION_TEXT =
  'Disconnect will completely remove all of your calendar connections';
const DELETE_CALENDAR_CONFIRMATION =
  'Are you sure you want to disconnect your calendar from Modern Health?';

export const CalendarModalDeleteConfirmation: React.FC<Props> = (props) => {
  const { cancelDelete, doDelete, deleteProfileName, isLastCalendar, working } = props;
  const classes = useStyles();
  const title = isLastCalendar ? LAST_CALENDAR_CONFIRMATION_TEXT : DELETE_CALENDAR_CONFIRMATION;

  return (
    <DialogContent
      className={classes.dialogContent}
      data-testid={CalendarModalTestID.ConfirmDeleteView}
    >
      <div className={classes.deleteConfirmContainer}>
        <div className={classes.iconDisplayContainer}>
          <div className={classes.iconDisplayBgRed}>
            <CalendarModalDeleteIcon />
          </div>
        </div>
        <DialogTitle
          className={classes.deleteConfirmTitle}
          data-testid={CalendarModalTestID.ConfirmDeleteTitle}
        >
          {title}
        </DialogTitle>
        <Typography className={classes.deleteConfirmText}>{deleteProfileName}</Typography>
        <div className={classes.deleteConfirmButtonContainer}>
          <Button
            onClick={cancelDelete}
            variant="outlined"
            className={classes.padRight}
            disabled={working}
            data-testid={CalendarModalTestID.CancelButton}
          >
            Cancel
          </Button>
          <MHButton
            extraClasses={[classes.redBg]}
            onClick={doDelete}
            disabled={working}
            data-testid={CalendarModalTestID.DeleteButton}
          >
            Disconnect
          </MHButton>
        </div>
      </div>
    </DialogContent>
  );
};
